import React, { useState } from 'react';
import { formatFastApiDetail } from '../utils/fastApiError';

export default function AdminLogin({ onLoggedIn }) {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const submit = async () => {
    if (!password.trim() || loading) return;
    setLoading(true);
    setError('');
    try {
      const res = await fetch('/api/admin/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
        credentials: 'include',
      });
      if (res.ok) {
        setPassword('');
        onLoggedIn?.();
        return;
      }
      const data = await res.json().catch(() => ({}));
      setError(formatFastApiDetail(data?.detail) || '登录失败');
    } catch {
      setError('网络错误');
    } finally {
      setLoading(false);
    }
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter') submit();
  };

  return (
    <div className="glass cardPad">
      <h2 className="h1">Administer</h2>
      <p className="subtle">输入管理员密码登录。</p>
      <div className="divider" />
      <div className="toolbar">
        <input
          className="input"
          type="password"
          placeholder="Admin password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={onKeyDown}
          style={{ flex: 1, minWidth: 240 }}
        />
        <button className="pillBtn" onClick={submit} disabled={loading || !password.trim()}>
          {loading ? '登录中…' : '登录'}
        </button>
      </div>
      {error ? (
        <div style={{ marginTop: 12 }}>
          <span className="tag tagWarn">{error}</span>
        </div>
      ) : null}
    </div>
  );
}


